<template>
  <div class="flex items-center ml-5">
    <div v-if="checked"><input type="checkbox" checked/></div>
    <div v-else><input type="checkbox"/></div>
  </div>
</template>

<script>
  export default {
    name: 'CheckBoxCellTemplate',
    computed: {
      checked() {
        return this.$data.data[this.$data.data.column.checked];
      }
    }
  }
</script>
